import DecoratedLink from '@js/DecoratedLink'
import Toast from '@js/Toast'

/**
 * Searches for download links and adds an icon and Toast notification.
 *
 * @extends DecoratedLink
 */
class DownloadLink extends DecoratedLink {
    constructor(element) {
        const hasDownload = typeof element.download !== 'undefined'
        const filename = element.download || element.href.split('/').pop()
        const srFilename = filename.toLowerCase() === element.textContent.toLowerCase() ? 'file' : filename

        super(element, {
            iconName: 'fa-file-arrow-down',
            iconStyle: 'fa-solid',
            classSuffix: 'download',
            srMessage: hasDownload ? `download ${srFilename || 'file'}` : undefined
        })

        if (sir.isEditor) return

        if (hasDownload) {
            element.addEventListener('click', () => {
                setTimeout(() => {
                    new Toast(`Downloading <strong>${filename}</strong>`)
                }, 150)
            })
        }
    }
}

DownloadLink.create('a[download]:not(.undecorated-download)')
